module.exports = __webpack_public_path__ + "img/PROPIOS.2d8b54b1.png";